import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useAppLoading } from '@/stores/app/loading';
import { useAppSnackbar } from '@/stores/app/snackbar';
import { useApprovalFlows } from '@/stores/jobProfiles/approvalFlows';
import { getApprovalsConfig, updateApprovalsConfig } from '@/api/settings';

export const useApprovalsSettings = defineStore('approvalsSettings', () => {
  const { setLoading } = useAppLoading();
  const { addErrorSnackbar, addSuccessSnackbar } = useAppSnackbar();

  const { fetchTemplates } = useApprovalFlows();

  const defaultTemplateUlid = ref(null);

  const loadApprovalsSettings = async () => {
    const data = await getApprovalsConfig();
    defaultTemplateUlid.value = data?.default_template_ulid;
  };

  const load = async () => {
    try {
      setLoading(true);

      await Promise.allSettled([
        fetchTemplates(),
        loadApprovalsSettings(),
      ]);
    } catch (err) {
      addErrorSnackbar({
        text: `Could not load the approvals settings: ${err}`,
      });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const updateDefaultApprovalTemplate = async (ulid) => {
    try {
      const data = await updateApprovalsConfig({
        default_template_ulid: ulid,
      });

      defaultTemplateUlid.value = data?.default_template_ulid;

      addSuccessSnackbar({
        text: 'Default approval template updated',
      });
    } catch (err) {
      addErrorSnackbar({
        text: `Could not update the approvals default template: ${err}`,
      });

      throw err;
    }
  };

  return {
    defaultTemplateUlid,
    load,
    loadApprovalsSettings,
    updateDefaultApprovalTemplate,
  };
});
